import request from './request';
// 家桩接口
export enum TimerType {
  ONCE = 1,
  REPEAT = 2
}
export interface TimerOpts {
  ssid: string;
  timer: string;
  endTimer?: string;
  timerType: TimerType;
  enable: boolean;
  handleMode: number;
}
export interface TaskResponse {
  taskId: number;
}
// 设置家桩定时充电配置
export function configTimer(data: TimerOpts): Promise<TaskResponse> {
  return request<TimerOpts, TaskResponse>(
    '/v5/charge/private-pile/timer',
    data,
    'POST'
  );
}

export enum GunStatusEnum {
  // 空闲
  FREE = '0',
  // 充电中
  CHARGING = '1',
  // 故障
  ERROR = '2',
  // 已插枪
  HASGUN = '3',
  // 充满
  FULL = '4',
  // 离线
  OFFLINE = '5',
  // 暂停
  SUSPENDED = '6',
  // 预约-7
  APPOINTMENT = '7',
  // 已上锁
  LOCKED = '9',
  // 未知：等待连接
  // UNKNOWN = '-1',
  // 其他状态一并忽略
  DEFAULT = 'DEF'
}

export function getPileStatus(
  ssid: string
): Promise<{ gunStatus: GunStatusEnum }> {
  return request<{ ssid: string }, { gunStatus: GunStatusEnum }>(
    '/v5/charge/private-pile/status/get',
    {
      ssid
    }
  );
}
export enum UserTypeEnum {
  HOST = 1,
  GUEST = 2
}

export interface PileConfig {
  userType: UserTypeEnum;
  openLockMode: boolean;
  openChargeTimerMode: boolean;
  timer: string;
  timerType: TimerType;
  authCount?: number;
  gunStatus: any;
  endTimer: string;
  showEndTimer: Int16Array;
}
// 获取配置
export function getPileConfig(ssid: string): Promise<PileConfig> {
  return request<{ ssid: string }, PileConfig>(
    '/v5/charge/private-pile/info/get',
    {
      ssid
    }
  );
}
export enum TaskTypeEnum {
  LOCK = 0,
  TIMER = 1
}
export enum TaskStatusEnum {
  ING = 0,
  SUCCESS = 1,
  FAIL = 2
}
export interface TaskResult {
  type: TaskTypeEnum;
  status: TaskStatusEnum;
}

// 激活4G连接接口
export function activate4G(ssid: string): Promise<any> {
  return request<{ ssid: string }, any>(
    '/v5/charge/private/pile/activate4g',
    {
      ssid
    },
    'POST'
  );
}

// 家桩配置接口
export function privatePileConfig(): Promise<any> {
  return request<{}, any>('/v5/charge/private-pile/config', {}, 'POST');
}

// 获取任务结果
export function getTaskResult(taskId: number): Promise<TaskResult> {
  return request<{ taskId: number }, TaskResult>(
    '/v5/charge/private-pile/task/get',
    {
      taskId
    }
  );
}
// 发起连接
export function sendConnect(ssid: string): Promise<any> {
  return request<{ ssid: string }, any>(
    '/v5/charge/private-pile/connect/send',
    {
      ssid
    }
  );
}
// 启停防盗锁
export function configLock({ ssid, open }): Promise<TaskResponse> {
  return request<{ ssid: string; open: boolean }, TaskResponse>(
    '/v5/charge/private-pile/mode/allowLock',
    {
      ssid,
      open
    },
    'POST'
  );
}

export enum LockActionEnum {
  UNLOCK = 0,
  LOCK = 1
}

export function controlLock({
  ssid,
  action
}: {
  ssid: string;
  action: LockActionEnum;
}): Promise<TaskResponse> {
  return request<{ ssid: string; action: LockActionEnum }, TaskResponse>(
    '/v5/charge/private-pile/lock/control',
    {
      ssid,
      action
    },
    'POST'
  );
}


export function getInsuranceStatus({ ssid }: { ssid: string; }): Promise<{insuranceURL:string}> {
  return request<{ ssid: string }, {insuranceURL:string}>(
    '/v5/charge/private-pile/getInsuranceStatus',
    { ssid },
    'GET'
  );
}
